import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { ValueChangeEvent } from '@angular/forms';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-lib-backing-block',
  templateUrl: './backing-block.component.html',
  styleUrls: ['./backing-block.component.css'],
})
export class BackingBlockComponent implements OnInit {
  @Output() backingChanged = new EventEmitter<boolean>();
  @Input() entityType!: 'idea' | 'solution' | 'thinktank';
  @Input()
  set isBackedByUser(value: boolean) {
    // keep the signal synced with whatever the parent passes in
    this.entityBacked.set(value);
  }
  @Input() hasCommitted!: boolean;
  entityBacked = signal(false);

  constructor() {}

  ngOnInit() {
    environment.log('Backing Block Component for ', this.entityType);
  }

  onSwitchChange(event: ValueChangeEvent<boolean>) {
    const newValue = event.value;

    this.entityBacked.set(newValue);

    this.backingChanged.emit(newValue);
  }

  formatEntityType(type: string): string {
    switch (type) {
      case 'idea':
        return 'Idea';
      case 'solution':
        return 'Solution';
      case 'thinktank':
        return 'Think Tank';
      default:
        return type;
    }
  }
}
